export default "__VITE_ASSET__DCRR_qc___"